<template>
  <div id="autoCompleteContainer">
    <v-autocomplete
      :value="value"
      v-on:input="$emit('input', $event)"
      :model="value"
      browser-autocomplete="new-password"
      autocomplete="false"
      :hide-details="true"
      :single-line="true"
      :show="!isHidden"
      :label="label"
      :items="autocompleteData"
      :dont-fill-mask-blanks="true"
    ></v-autocomplete>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetify from "vuetify";
import Vuelidate from "vuelidate";
import { required } from "vuelidate/lib/validators";

Vue.use(Vuetify);
Vue.use(Vuelidate);

export default {
  name: "auto-complete-edit-text",
  data() {
    return {
      autocompleteData: { Imperatriz: null, Curitiba: null }
    };
  },
  props: {
    id: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    isHidden: {
      type: Boolean,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: null
    },
    source: {
      type: String,
      default: null
    }
  },
  methods: {
    updateValue: function(value) {
      this.$emit("input", value);
    }
  },
  created() {
    this.autocompleteData = require("@/assets/" + this.source + ".json");
  }
};
</script>

<style lang="scss">
#autoCompleteContainer {
  background: #efefef;
  border-radius: 4px;

  .v-select__slot {
    input {
      border-bottom: none;
      margin-bottom: 10px;
    }
    input:focus {
      border-bottom: none !important;
      box-shadow: none !important;
    }
  }

  .v-autocomplete__content {
    position: fixed;
  }
}
// @media (max-width: 991px) {
//   #edit-text {
//     margin-top: 10px;
//     margin-bottom: 5px;
//   }
// }

// #edit-text {
//   input {
//     border-bottom: 0px;
//     box-shadow: none;
//     box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
//     background: #efefef;
//     font-size: 14px;
//     padding-left: 15px;
//     padding-right: 15px;
//     border-radius: 4px;
//     height: 44px;
//   }
//   label {
//     margin-left: 15px;
//     pointer-events: none;
//   }
//   label.active {
//     margin-left: 5px;
//     padding-bottom: 5px;
//     color: #474747;
//     font-size: 14px;
//   }
//   font-size: 14px;
//   margin-top: 20px;
// }
</style>



// WEBPACK FOOTER //
// src/components/fields/AutoCompleteEditText.vue